import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import Icon from '../../icon';
import RoutableNotEditableLink from '../../routableNotEditableLink';
import { TNavigationBarItemProps } from '../types/navigationBarItem.types';

const NavigationItems: FC<TNavigationBarItemProps & { isNotClickable: boolean }> = (props) => {
  const { isLast, item, isNotClickable, onClick } = props;

  const chevronRightIcon = <Icon iconName="arrow-chevron-right" size={iconSize.md} extraClassName="nav-bar__chevron-icon" color="white" />;

  if (isLast) {
    return <>{item.text}</>;
  } else if (isNotClickable) {
    return (
      <>
        {item.text}
        {chevronRightIcon}
      </>
    );
  } else {
    return (
      <>
        <RoutableNotEditableLink href={item.url} onClick={onClick}>
          {item.text}
        </RoutableNotEditableLink>
        {chevronRightIcon}
      </>
    );
  }
};

export default NavigationItems;
